
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Password } from "primereact/password";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
    setDialogCreateNewPasswordConfirmedVisible,
    setDialogCreateNewPasswordVisible
} from "../Slice/DialogSlice";
import { AppDispatch, RootState } from "../Store";
import { useChangePasswordByLinkMutation } from "../api/ProfileAPI";


/**
 * @author noone
 */
export default function CreateNewPasswordFromResetLinkDialog() {

    const navigate = useNavigate();
    const [oldPassword, setOldPassword] = useState<string>();
    const [newPassword, setNewPassword] = useState<string>();
    const [confirmNewPassword, setConfirmNewPassword] = useState<string>();
    const createNewPasswordVisible = useSelector((state: RootState) => state.authReducer.dialog.createNewPasswordVisible);
    const linkuid = useSelector((state: RootState) => state.allParameter.linkuid);
    const dispatch = useDispatch<AppDispatch>();
    const [changePasswordByLinkMutation] = useChangePasswordByLinkMutation();

    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <div>
                <h3>Change Password</h3>
            </div>
            <p>Your new password must be different from previous used passwords.</p>
        </div>
    );

    const footerContent = (
        <div>
            <Button
                label="RESET PASSWORD"
                //TODO pruefen
                disabled={(oldPassword === undefined && newPassword === undefined) 
                     || (newPassword !== confirmNewPassword)
                }
                onClick={() => {
                    changePasswordByLinkMutation({
                        uid: linkuid!,
                        password: newPassword!,
                        passwordRepeat: confirmNewPassword!
                    }).unwrap()
                    .then(() => {
                        dispatch(setDialogCreateNewPasswordConfirmedVisible(true));
                        dispatch(setDialogCreateNewPasswordVisible(false));
                        navigate('/');
                    })
                    .catch(error => 'Es ist ein Fehler aufgetreten');
                

                }} />
        </div>
    );

    return (
        <Dialog
            header={headerElement}
            footer={footerContent}
            visible={createNewPasswordVisible}
            style={{ width: '50vw' }}
            onHide={() => {
                dispatch(setDialogCreateNewPasswordVisible(false));
                navigate('/');
            }}
        >
            {(window.location.pathname === '/myspace/personalinformation') &&
                <div><label>Aktuelles Passwort</label>
                    <Password
                        value={oldPassword}
                        onChange={(event) => {
                            setOldPassword(event.target.value);
                        }}
                        feedback={false}
                        toggleMask
                        tabIndex={1} />
                </div>
            }

            <label>Neues Passwort</label>
            <Password
                value={newPassword}
                onChange={(event) => {
                    setNewPassword(event.target.value);
                }}
                feedback={true}
                toggleMask
                tabIndex={1} />

            <label>Confirm new Password</label>
            <Password
                value={confirmNewPassword}
                onChange={(event) => {
                    setConfirmNewPassword(event.target.value);
                }}
                feedback={false}
                toggleMask
                tabIndex={2} />
        </Dialog>
    )
}